import Service from '../service'
import ProviredIpsMdl from '@/models/HumanResource/HrProviredIps'

export default class extends Service {
    static model = ProviredIpsMdl
}
